export enum SubscriptionPlan {
  Basic = "basic",
  Premium = "premium",
  Complete = "complete",
}
